import { render, staticRenderFns } from "./ClientDataTable.vue?vue&type=template&id=3dd82518"
import script from "./ClientDataTable.vue?vue&type=script&lang=js"
export * from "./ClientDataTable.vue?vue&type=script&lang=js"
import style0 from "./ClientDataTable.vue?vue&type=style&index=0&id=3dd82518&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports